export type UsageMode = 'standalone' | 'hub';

let usageMode: UsageMode = 'standalone';

export function setUsageMode(mode: UsageMode): void {
  usageMode = mode;
}

export function getUsageMode(): UsageMode {
  return usageMode;
}
